import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Agency } from 'src/app/models/Agency';
import { AgencyFilter } from 'src/app/models/AgencyFilter';
import { UserPayment } from 'src/app/models/UserPayment';
import { environment } from 'src/environments/environment';

import { PaginatedResult } from '../model/paginated-result';
import { Payment } from './../../models/Payment';

export const PENDING = 'pending';
export const PAID = 'paid';

@Injectable({
  providedIn: 'root'
})
export class AgencyService {

  constructor(
    private http: HttpClient
  ) { }

  findById(id: string): Observable<Agency> {
    return this.http.get<Agency>(`${environment.apiUrl}/agency/${id}`);
  }

  savePayment(agency: Agency, payment: Payment) {
    return this.http.post(`${environment.apiUrl}/agency/${agency.id}`, payment);
  }

  listAgencies(page: number = 1, pageSize: number = 10, filter: AgencyFilter = null, order: string = 'name', inverted: boolean = false): Observable<PaginatedResult<Agency[]>> {
    let url = `${environment.apiUrl}/agency?page=${page}&per_page=${pageSize}`;
    if (filter) {
      url += '&filter=' + encodeURIComponent(JSON.stringify(filter));
    }
    if (order) {
      url += `&order=${order}`;
    }

    // `inverted` só vai na URL quando é de fato um booleano — mandar
    // "undefined"/"null" como texto (CU-17tm466u6ga) deixava o back com um
    // valor que não é nem "true" nem "false" para interpretar.
    if (inverted !== null && inverted !== undefined) {
      url += `&inverted=${!!inverted}`;
    }

    return this.http.get<PaginatedResult<Agency[]>>(url);
  }

  listPeriods(id: string) {
    return this.http.get(`${environment.apiUrl}/agency/${id}/periods`);
  }

  listPayments(agencyId: string) {
    return this.http.get<PaginatedResult<UserPayment[]>>(`${environment.apiUrl}/agency/${agencyId}/payments`);
  }

  deletePayment(id: number) {
    return this.http.delete(`${environment.apiUrl}/agency/payments/${id}`);
  }
}
